// Utilitários de formatação e geração de protocolo
// Exporta tanto os nomes originais quanto os aliases com prefixo "formatar"

export function formatCPF(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 11)
  return digits
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
}
// alias
export const formatarCPF = formatCPF

export function formatCNPJ(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 14)
  return digits
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})$/, '$1-$2')
}
export const formatarCNPJ = formatCNPJ

export function formatCEP(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 8)
  return digits.replace(/(\d{5})(\d{1,3})$/, '$1-$2')
}
export const formatarCEP = formatCEP

export function formatTelefone(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 11)
  if (digits.length <= 10) {
    return digits
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d{1,4})$/, '$1-$2')
  }
  return digits
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{1,4})$/, '$1-$2')
}
export const formatarTelefone = formatTelefone

export function formatData(iso: string): string {
  if (!iso) return '-'
  try {
    const d = new Date(iso)
    return d.toLocaleDateString('pt-BR')
  } catch {
    return '-'
  }
}
// alias usado em todos os componentes
export const formatarData = formatData

export function formatDataHora(iso: string): string {
  if (!iso) return '-'
  try {
    const d = new Date(iso)
    return d.toLocaleString('pt-BR')
  } catch {
    return '-'
  }
}
// alias usado em todos os componentes
export const formatarDataHora = formatDataHora

export function nowISO(): string {
  return new Date().toISOString()
}

/**
 * Versão SÍNCRONA de gerarProtocolo — gera sufixo aleatório de 6 dígitos
 * para evitar enumeração sequencial e preservar privacidade entre processos.
 * Formato: AAAAMMDD-XXXXXX (ex: 20260612-483920)
 */
export function gerarProtocolo(_totalExistente: number = 0): string {
  const hoje = new Date()
  const aaaa = hoje.getFullYear()
  const mm = String(hoje.getMonth() + 1).padStart(2, '0')
  const dd = String(hoje.getDate()).padStart(2, '0')
  const prefixo = `${aaaa}${mm}${dd}`
  // Número aleatório entre 100000 e 999999 para evitar sequências previsíveis
  const rand = String(Math.floor(100000 + Math.random() * 900000))
  return `${prefixo}-${rand}`
}

/**
 * Versão ASSÍNCRONA — gera protocolo aleatório e verifica unicidade no banco.
 * Formato: AAAAMMDD-XXXXXX (sufixo aleatório 6 dígitos)
 */
export async function gerarProtocoloUnico(): Promise<string> {
  const hoje = new Date()
  const aaaa = hoje.getFullYear()
  const mm = String(hoje.getMonth() + 1).padStart(2, '0')
  const dd = String(hoje.getDate()).padStart(2, '0')
  const prefixo = `${aaaa}${mm}${dd}`

  const { lumi } = await import('@/lib/lumi')

  // Gera aleatório e verifica colisão (muito improvável, mas garante unicidade)
  for (let tentativa = 0; tentativa < 10; tentativa++) {
    const rand = String(Math.floor(100000 + Math.random() * 900000))
    const candidato = `${prefixo}-${rand}`
    const resultado = await lumi.entities.solicitacoes.list({
      filter: { protocolo: candidato },
      limit: 1,
    })
    if ((resultado?.list?.length || 0) === 0) return candidato
  }
  // Fallback extremamente improvável
  return `${prefixo}-${String(Math.floor(100000 + Math.random() * 900000))}`
}
